import { AxiosResponse } from 'axios';
import { axios } from '@repository/RequestClient';
import RecruitmentUrlRq from '@domain/rq/recruitment/RecruitmentUrlRq';
import { RecruitmentUrlRs } from '@domain/rs/recruitment/RecruitmentUrlRs';

const urlPrefix = '/recruitment';

export default interface RecruitmentRepo {
  //JF3 공고 도메인 조회
  fetchRecruitmentUrl(rq: RecruitmentUrlRq): Promise<AxiosResponse<RecruitmentUrlRs>>;
}

export class RemoteRecruitmentRepo implements RecruitmentRepo {
  fetchRecruitmentUrl(rq: RecruitmentUrlRq): Promise<AxiosResponse<RecruitmentUrlRs>> {
    return axios.get(`${urlPrefix}/url`, { params: rq });
  }
}
